module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon.ico
// module id = 844
// module chunks = 0